export const S3_URL = 'https://s3-ap-southeast-1.amazonaws.com/plus-website-production-images/';
export const SITE_NAME = 'Link';
export const CUSTOMER_SERVICE_NUMBER = '6380 5858';
